import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../Components/vendorprofilebody/profilebody.module.css';
import { faEye } from '@fortawesome/free-solid-svg-icons';

const AddNewVendorComp = () => {
    return (
        <div className={styles.profilebodyContainer}>
            <div className={styles.profileheader}>
                <h2>Add new user</h2>
                <button className={styles.editbtn}>Back to List</button>

            </div>

            <div className={styles.profilebodyContent}>
                <div className={styles.profilebodyDetails} style={{ width: '100%' }}>
                    <div style={{ display: 'flex', gap: '14px' }}>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            Full name
                            <div className={styles.logininputContainer}>
                                <input
                                    type="text"
                                    id="fullName"
                                    name="fullName"
                                    value="Dianne"
                                />
                            </div>
                        </label>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            Phone number
                            <div className={styles.logininputContainer}>
                                <input
                                    type="text"
                                    id="fullName"
                                    name="fullName"
                                    value="Dianne"
                                />
                            </div>
                        </label>
                    </div>
                    <div style={{ display: 'flex', gap: '14px' }}>
                        <label className={styles.addCatLabel} style={{ width: '49.2%' }}>
                        Email id
                            <div className={styles.logininputContainer}>
                                <input
                                    type="text"
                                    id="fullName"
                                    name="fullName"
                                    value="Dianne"
                                />
                            </div>
                        </label>
                    </div>
                    <div style={{ display: 'flex', gap: '14px' }}>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            New Password
                            <div className={styles.logininputContainer}>
                                <input
                                    type="password"
                                    name="password"
                                    placeholder="********"
                                /*  className={styles.addCatInput} */
                                />
                                <FontAwesomeIcon
                                    icon={faEye}
                                    className={styles.loginpasswordIcon}
                                />
                            </div>
                        </label>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            Confirm Password
                            <div className={styles.logininputContainer}>
                                <input
                                    type="password"
                                    name="password"
                                    placeholder="********"
                                />
                                <FontAwesomeIcon
                                    icon={faEye}
                                    className={styles.loginpasswordIcon}
                                />
                            </div>
                        </label>
                    </div>
                    <div className={styles.mainBtns}>
                        <button className={styles.addBtn}>Save user</button>
                        <button className={styles.quoteBtn}>Cancel</button>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default AddNewVendorComp